export function docTypeSwitch({ eventType, docType, id }: { eventType: string; docType: string; id: string }) {
  switch (docType) {
    case 'contact':
      return `/people/contact/${id}?activityTab=${eventType}&viewTab=activities`
    case 'company':
      return `/people/companies/${id}?activityTab=${eventType}&viewTab=activities`
    case 'deal':
      return `/deals/edit/${id}?activityTab=${eventType}&viewTab=activities`
    default:
      return null
  }
}
